import { config } from '../../utils/config';

export default {
	'... or logout': '... o fai logout',
	'Renew your authentication': 'Rinnova la tua autenticazione',
	'Use the credentials we gave you': 'Utilizza le credenziali che ti abbiamo fornito',
	'Sign In / Register': 'Accedi / Registrati',
	'Sign In with your social account': 'Accedi con i tuoi account social',
	'Sign In with your social accounts': 'Accedi con i tuoi account social',
	'Sign In with username and password': 'Accedi con username e password',
	'GOOGLE login button': 'Accedi con Google',
	'Sign in with GOOGLE': 'Accedi con Google',
	'FACEBOOK login button': 'Accedi con Facebook',
	'Sign in with FACEBOOK': 'Accedi con Facebook',
	'LINKEDIN login button': 'Accedi con Linkedin',
	'Sign in with LINKEDIN': 'Accedi con Linkedin',
	'Registration - Terms & Conditions': 'Registrazione / Termini & Condizioni',
	'To continue, you must agree to Gruppo Food Terms of Service and Privacy Policy':
		'Per continuare devi accettare la Privacy Policy e Termini & Condizioni di Gruppo Food',
	'Click here to read them in English':
		'Click here to read Terms and Conditions in english',
	'I Agree': 'Accetto',
	'Registration - Business Profile': 'Registrazione / Profilo business',
	'We reserve specific functionalities to suppliers, buyers and food service operators so we have to be sure you work in the food business.':
		'Riserviamo alcune funzionalità specifiche a produttori, buyer e operatori del settore food service; per questo motivo dobbiamo accertare la tua appartenenza al settore',
	"We can't accept public email domains (@gmail.com, @aol.com, ...)":
		'Non verranno accettati domini email pubblici (@gmail.com, @aol.com, ...)',
	Continue: 'Continua',
	'We sent you a verification email to': "Ti abbiamo inviati una mail all'indirizzo",
	'Please click the link in it to complete the registration':
		'Clicca il link contenuto al suo interno per terminare la registrazione',
	'Change work email': 'Cambia indirizzo email',
	loading: 'Caricamento...',
	Hello: 'Benvenuto',
	'Thanks for validating': "Grazie per aver effettuato l'accesso",
	'You have been successfully registered as a': 'Sei stato registrato come',
	CONSUMER: 'Consumatore',
	'as we related you to': 'e sei stato associato a',
	"If you think we're wrong please": 'Se pensi si sia verificato un problema',
	'contact us': 'contattaci',
	Proceed: 'Procedi',
	'Insert your job email address': 'Inserisci il tuo indirizzo email di lavoro',
	'grantToken error': 'Errore accesso social network - token non valido',
	'Authentication error': 'Errore di autenticazione',
	'If the problem persists': 'Se il problema persiste',
	Close: 'Chiudi',
	Registration: 'Registrazione',
	'Role CONSUMER': 'No, sono un consumatore attento',
	'Role PRODUCER': 'Sì, sono un professionista del settore',
	Back: 'Indietro',
	'generic email error': 'Email già presente nel database',
	"If your company doesn't have a private email domain":
		'Se la tua azienda non ha un proprio dominio email',
	'consumerOnlyEmail error':
		"Questo dominio email è di un provider pubblico. Non possiamo quindi dedurre e garantire la tua appartenenza ad un'azienda del settore. Per favore usa un dominio di proprietà aziendale oppure contattaci",
	'Thanks for signing in': 'Grazie per esserti autenticato',
	'Waiting review explanation html':
		'<p>Il tuo utente è stato creato e la mail verificata.</p><p>Per garantire pieno accesso alla piattaforma è comunque necessario attendere la creazione del profilo aziendale da parte nostra. Verrai notificato di avvenuta creazione o rifiuto tramite email al termine del processo.</p>',
	'Waiting Review': 'Email verificata',
	// 'Sign In again to renew your session': '',
	'... or Logout': '... o fai logout',
	'no roles registration intro':
		"L'accesso è permesso solo su invito a giuria selezionata.",
	'options.authToken error': 'Errore di accesso al social - ricontrollare impostazioni',
	' Social Account': 'Collega un account Social',
	'switch to social explanation title':
		'Stiamo dismettendo gli accessi tramite password',
	'switch to social explanation html': `Collega un tuo account social e d'ora potrai accedere con un click senza dover tenere a mente le credenziali.`,
	'Associate a social account to your user': 'Scegli un account social da associare',
	'Maybe later': 'Ricordamelo più tardi',
	'grantToken INVALID_VALUE error': 'Codice di autenticazione non valido',
	'Temporary consumer explanation':
		'Abbiamo ricevuto la tua richiesta di iscrizione come professionista del settore. Riceverai una email di avviso non appena avremo convalidato la tua richiesta.',
	'options.sfContactId ALREADY_PRESENT error': 'Ci dispiace, si è verificato un errore.',
	'options.sfContactId INVALID_REF error': 'Ci dispiace, si è verificato un errore.',
	'options.sfContactId UNSUPPORTED_FORMAT error':
		"C'è qualcosa che non va nell'url da cui sei atterrato.",
	'options.sfContactId INVALID_VALUE error':
		"C'è qualcosa che non va nell'url da cui sei atterrato.",
	'options.sfContactId MUST_BE_UNIQUE error':
		"C'è qualcosa che non va nell'url da cui sei atterrato.",
	'Registration intro': 'Lavori nella filiera agroalimentare?',
	'Upgrade role': 'Lavori nella filiera agroalimentare?',
	Retry: 'Riprova',
	'alreadyUsedEmail error':
		'Esiste già un account associato a questa email lavorativa.<br />Se sei il proprietario di questo indirizzo ' +
		'<a href="mailto:' +
		config.SUPPORT_EMAIL +
		'">contattaci</a>.',
	'Sign In': 'Accedi',
	'options.email INVALID_VALUE error': 'Credenziali errate',
	'upgrade role introduction html':
		'Riserviamo alcune funzionalità specifiche a produttori, buyer e operatori del settore food service; per questo motivo dobbiamo accertare la tua appartenenza al settore',
	'Upgrade to Professional': 'Sono un professionista del settore',
	'remember switch to social title': 'Account Social collegato',
	'remember social account html':
		'Ricorda che puoi accedere senza digitare email e password utilizzando il tuo account social.',
	'social login type associated': 'Account social collegato',
	proceed: 'Continua',
};
